
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kody",
      function () {
        return require("private-next-pages/kody.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kody"])
      });
    }
  